/**
* Obtiene los IDs de los deportes de una pool.
* Soporta: .sports (array), .sport (objeto con id), .sport_id (legacy).
*/

export function getPoolSportIds(pool) {
 if (Array.isArray(pool.sports) && pool.sports.length > 0) {
   return pool.sports.map((s) => s.id).filter((id) => id != null);
 }
 if (pool.sport && (pool.sport.id != null || pool.sport.sport_id != null)) {
   return [pool.sport.id != null ? pool.sport.id : pool.sport.sport_id];
 }
 if (pool.sport_id != null) {
   return [pool.sport_id];
 }
 return [];
}
